module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grey section"
  }, [_c('h1', {
    staticClass: "ui center aligned header"
  }, [_vm._v("\n    Relevant documents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui middle aligned very relaxed center aligned stackable equal width grid container"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "ui centered card",
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-One-Pager.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "center aligned content"
  }, [_c('img', {
    staticClass: "ui small middle aligned image",
    attrs: {
      "src": require("../assets/docs/onepager.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "center aligned header"
  }, [_vm._v("\n            One Pager\n            "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "us flag"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-One-Pager-CN.pdf"
    }
  }, [_c('i', {
    staticClass: "cn flag"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-One-Pager-RU.pdf"
    }
  }, [_c('i', {
    staticClass: "ru flag"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "ui centered card",
    attrs: {
      "href": "https://github.com/aragon/whitepaper/raw/master/Aragon%20Whitepaper.pdf"
    }
  }, [_c('div', {
    staticClass: "center aligned content"
  }, [_c('img', {
    staticClass: "ui small middle aligned image",
    attrs: {
      "src": require("../assets/docs/whitepaper.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "center aligned header"
  }, [_vm._v("\n            Whitepaper\n            "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "us flag"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/aragon/whitepaper/raw/master/Aragon%20Whitepaper-CN.pdf"
    }
  }, [_c('i', {
    staticClass: "cn flag"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "ui centered card",
    attrs: {
      "href": "https://github.com/aragon/docs/raw/master/Aragon-Development-Plan.pdf",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "center aligned content"
  }, [_c('img', {
    staticClass: "ui small middle aligned image",
    attrs: {
      "src": require("../assets/docs/devplan.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "center aligned header"
  }, [_vm._v("\n            Development Plan\n            "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "us flag"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10c1cecf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Docs.vue
// module id = 506
// module chunks = 1